import { render } from "./postTemplate.vue?vue&type=template&id=0b6705a4&scoped=true"
import script from "./postTemplate.vue?vue&type=script&lang=js"
export * from "./postTemplate.vue?vue&type=script&lang=js"

import "./postTemplate.vue?vue&type=style&index=0&id=0b6705a4&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6705a4"]])

export default __exports__